import React, { useCallback } from 'react';
import styles from './Entry.module.css';
import {
  EntryPageElement,
  EntryPageElementInterface,
} from '../EntryPageElement';

export const MobileView = (): JSX.Element => {
  const entryPageElement: EntryPageElementInterface = EntryPageElement();
  return (
    <React.Fragment>
      <div className={styles.entryDiv}>
        <div className={styles.entryPagePartnershipButtonDiv}>
          <footer
            className={styles.entryPagePartnershipButtonFooter}
            id="entry-page-blue-background"
          />
          <div className={styles.entryPagePartnershipButtonDiv1}>
            <b className={styles.entryPagePartnershipTextB}>
              Click here if you are a Teacher / Business partner
            </b>
            <img
              className={styles.entryPagePartnershipButtonIcon}
              id="entry-page-partnership-button"
              alt=""
              src="assets/entry/entry-page-partnership.svg"
            />
          </div>
        </div>
        <div className={styles.entryPageBgDiv} />
        <header className={styles.headerGroup} id="common-navi-bar">
          <img
            className={styles.bbaLogoIcon}
            id="entry-header"
            alt=""
            src="assets/common/bba-logo.svg"
          />
        </header>
        <main className={styles.entryMainGroup} id="entry-main-group">
          <div
            className={styles.entryPageSignupButton}
            id="entry-page-signup-button"
          >
            <div className={styles.primaryButtonDiv}>
              {entryPageElement.signupButton}
            </div>
          </div>
          <div
            className={styles.entryPageLoginButton}
            id="entry-page-login-button"
            tabIndex={1}
          >
            {entryPageElement.loginButton}
          </div>
          <div className={styles.entryMainGroupSectionDiv}>
            <section
              className={styles.entryMainGroupWelcomeImageSection}
              id="entry-main-group-welcome-image-group"
            >
              {entryPageElement.welcomeImageSection}
            </section>
            <div className={styles.entryMainGroupSectionMainDiv}>
              <b className={styles.allInOneSTEAMCurriculumPa}>
                All-in-one STEAM Curriculum Package
              </b>
              <div className={styles.sTEAMEducationReinvented}>
                <p className={styles.sTEAMEducationP}>STEAM Education,</p>
                <p className={styles.reinventedP}>{`Reinvented `}</p>
              </div>
              <div className={styles.entryMainGroupText1Div}>
                <img
                  className={styles.entryMainGroupText1Icon}
                  alt=""
                  src="assets/entry/entry-main-group-text-1-icon.svg"
                />
                <div className={styles.entryMainGroupText1TextDiv}>
                  STEAM E-Learning Platform
                </div>
              </div>
              <div className={styles.entryMainGroupText2Div}>
                <img
                  className={styles.entryMainGroupText1Icon}
                  id="entry-main-group-text-2-icon"
                  alt=""
                  src="assets/entry/entry-main-group-text-2-icon.svg"
                />
                <div className={styles.entryMainGroupText1TextDiv}>
                  Monthly Curriculum Kit
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </React.Fragment>
  );
};
